import { InputNumber } from 'antd'
import { MyForm } from '~/components/ui/MyForm'
import classNames from 'classnames'
import styles from '../AiForm.module.css'
import { ReferToScrollKeyEnum, SpellAnalysisImgType } from '~/graphqls/types'
import { MySlider } from '~/components/ui/MySlider'
import { useState } from 'react'
import { controlnetPatternArr } from '~/configs/ai'
import {
  creativityDegreeAtom,
  initImageUrlAtom,
  patternAtom,
  selectSizeAtom,
} from './atom'
import { useAtom } from 'jotai'
import useOptions from './useOptions'
import { PictureCardUpload } from '~/components/business/PictureCardUpload'
import { MyIcon } from '~/components/ui/MyIcon'
import { useType } from '../useType'
import FormLabelImgToTag from './FormLabelImgToTag'

export const NormalInitImageComp = () => {
  const [creativityDegree, setCreativityDegree] = useAtom(creativityDegreeAtom)
  const [pattern] = useAtom(patternAtom)
  const [initImageUrl, setInitImageUrl] = useAtom(initImageUrlAtom)
  const [selectSize] = useAtom(selectSizeAtom)

  const { curSizeOptions } = useOptions()

  const { isAD } = useType()

  /** 创意度字段名字使用 创意度 还是 二次元强度 */
  const show2dDensity = isAD && !controlnetPatternArr.includes(pattern)

  /** 底图提示比例 */
  const [initImageSize, setInitImageSize] = useState<string | null>(null)

  const matchSize = (ratio: number) => {
    let best: any
    let delta = 10000
    curSizeOptions.map(item => {
      const [w, h] = item.name.split(':')
      const _ratio = Number(w) / Number(h)
      const _delta = Math.abs(_ratio - ratio)
      if (_delta < delta) {
        delta = _delta
        best = item
      }
    })
    setInitImageSize(best.name as string)
  }

  const onInitImageUrlChange = (value: string) => {
    console.log(value, 'onInitImageUrlChange')
    const img = new Image()
    img.src = value
    img.onload = () => {
      matchSize(img.naturalWidth / img.naturalHeight)
    }

    setInitImageUrl(value)
  }

  return (
    <>
      <FormLabelImgToTag
        scrollId={ReferToScrollKeyEnum.referToImage}
        radioKey={SpellAnalysisImgType.REFERENCE}
        formLabel="参考图"
        formNotice="你可以上传一张参考图，参考图可以上传你原创的图片，或是使用无界AI创作功能生成的图片，或在无界版图拥有改编权的图片。最终生成画面将参考这张图进行，具体的方式为将其作为初始化画面，在此基础上进行迭代，最终画面会结合参考图和描述文本"
        hasRadio={!!initImageUrl}
      />
      <MyForm.Item className={classNames(styles.borderLessFormItem, '!mb-3')}>
        <PictureCardUpload
          className={classNames(
            styles.initImageUpload,
            'relative bg-neutral-100 !w-[152px] !h-[152px]'
          )}
          limit={10}
          showInfo={false}
          dirname="ai_init_image"
          onChange={val => onInitImageUrlChange(val)}
          value={initImageUrl}
          showDelete={true}
          onDelete={() => {
            setInitImageUrl(undefined)
          }}
          icon={
            <span className={classNames('text-neutral-400 w-6 h-6 block')}>
              <MyIcon icon="plussquare" className="text-[24px]" />
            </span>
          }
          label={<></>}
        />
      </MyForm.Item>
      {(initImageUrl || '')?.length > 0 && (
        <div className="flex items-center mb-3">
          <span className={classNames('text-neutral-500 w-[120px]')}>
            {show2dDensity ? '二次元强度' : '创意度'}
          </span>
          <MySlider
            className="flex-1"
            step={1}
            value={creativityDegree}
            onChange={val => {
              setCreativityDegree(val)
            }}
            tooltip={{ formatter: null }}
          />
          <InputNumber
            min={0}
            max={100}
            className={styles.inputNumberGroup}
            value={creativityDegree}
            onChange={val => {
              setCreativityDegree(Number(val?.toFixed(0)))
            }}
            addonAfter="%"
          />
        </div>
      )}
      {initImageSize &&
        initImageSize !== selectSize &&
        (initImageUrl || '')?.length > 0 && (
          <div className="text-xs text-neutral-500 py-2 px-4 mb-3 bg-neutral-200 rounded-xl">
            建议画面大小选择{initImageSize}效果更佳
          </div>
        )}
      {!show2dDensity &&
        creativityDegree <= 20 &&
        (initImageUrl || '')?.length > 0 && (
          <div className="text-xs text-neutral-500 py-2 px-4 mb-3 bg-neutral-200 rounded-xl">
            生成的新图与底图创意度低于20%，在没有获得底图改编权的情况下，您用于商业用途可能侵权，但不影响您用于交流学习
          </div>
        )}
      <div className="h-5"></div>
    </>
  )
}
